export default __webpack_public_path__ + "static/media/NoCards.9be4aadc.png";